import React, { FC } from 'react'
import text from 'styles/utility/text.module.scss'
import { FlexColumn } from 'components/Flex'
import { Spacer } from 'components/Utility'
import { SubDescription } from 'components/Typography'

type Props = {
  amount: number | null
  interval: string | null
  nextBillingDate: string | null
  planName: string | null
}

const ContractPlanCardBody: FC<Props> = (props) => {
  const { amount, interval, nextBillingDate, planName } = props

  return (
    <FlexColumn alignItems={'center'}>
      <h4 className={`${text.color_orange_main} ${text.font_large} ${text.font_bold}`}>{planName ?? 'プラン未設定'}</h4>
      {amount !== null && amount !== 0 && (
        <>
          {interval && (
            <>
              <Spacer size={4} />
              <p className={`${text.font_xxlarge} ${text.font_bold}`}>
                {amount.toLocaleString()}円(税込)/
                {interval === 'month' && '月額'}
                {interval === 'year' && '年額'}
              </p>
            </>
          )}
          <Spacer size={12} />
          {nextBillingDate && (
            <h4 className={`${text.color_grey_01} ${text.font_small}`}>次回請求日 : {nextBillingDate}</h4>
          )}
        </>
      )}
      {!amount && !interval && !nextBillingDate && !planName && (
        <SubDescription description={'sacriより設定が完了した後、ご連絡いたします'} />
      )}
    </FlexColumn>
  )
}

export default ContractPlanCardBody
